import React from 'react';
import loadable from '@loadable/component';

import { Helpers } from '../../../core/src/helpers';
import useUserData, { isCallCenter } from '../../../hooks/useUserData';

const CSRContainer = loadable(() => Helpers.retryFunc(() => import('./csr-container')));

export default ({ children }) => {
    const { userData } = useUserData();
    const isCSR = isCallCenter(userData);
    if (!isCSR) {
        return children ? children({}) : null;
    }
    return (
        <CSRContainer>
            {props => {
                return children && typeof children === 'function' ? children(props) : children;
            }}
        </CSRContainer>
    );
};
